export default class FeedbackOptionConstants {
  static readonly likeOptions: { key: string, text: string }[] = [
    { key: 'informative', text: 'Informative' },
    { key: 'helpful', text: 'Helpful' },
    { key: 'clear', text: 'Clear' },
    { key: 'other', text: 'Other' }
  ];
  static readonly dislikeOptions: { key: string, text: string }[] = [
    { key: 'factually_incorrect', text: 'Factually incorrect' },
    { key: 'missing_key_information', text: 'Missing key information' },
    { key: 'ignored_or_refused_instruction', text: 'Ignored or refused instruction' },
    { key: 'forgot_previous_context', text: 'Forgot previous context' },
    { key: 'harmful_or_offensive', text: 'Harmful or offensive' },
    { key: 'other', text: 'Other' }
  ];
}